import React, { useEffect, useRef, useState } from "react";
import { FaCamera, FaMicrophone, FaVideoSlash } from "react-icons/fa";
import {
  FaBell,
  FaCommentAlt,
  FaHeart,
  FaShare,
  FaSearch,
  FaChevronDown,
} from "react-icons/fa";
import Leftsidebar from "../components/sidebar/leftsidebar";
import LeftResponsivesidebar from "../components/sidebar/left-responsive";
import Rightsidebar from "../components/sidebar/rightsidebar";
import Headmenu from "../components/sidebar/headmenu";
import videoslash from "../assets/images/icons/video-slash.png";
import cameraoff from "../assets/images/icons/camera-off.png";
import golivecam from "../assets/images/icons/golive-cam.png";
import global from "../assets/images/icons/global.svg";
import profileimg from "../assets/profile.png";
import like from "../assets/images/icons/like.png";
import golivebanner from "../assets/images/golive-prf.png";
import axios from "axios";
import { io } from "socket.io-client";
import { IVSBroadcastClient, BasicStreamConfig } from "amazon-ivs-web-broadcast";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const API_ORIGIN = API_BASE_URL.replace(/\/api$/i, "");
const SOCKET_URL = API_ORIGIN; // adjust if different

// ✅ Base URL for APIs
const BASE_URL = API_BASE_URL;

export default function Golive() {
      const storedUser = sessionStorage.getItem("user") || localStorage.getItem("user");
      const user = storedUser ? JSON.parse(storedUser) : null;
const [startTime, setStartTime] = useState(null);
const formatDate = (date) => {
  if (!date) return "";
  return new Intl.DateTimeFormat("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date);
};
 const [profilePictureUrl, setProfilePictureUrl] = useState(() => {
    return sessionStorage.getItem("profilePictureUrl") || profileimg; // Default to placeholder image
  });
  // TEMP: replace this with your real logged-in user data
const profiledata = {
  id: sessionStorage.getItem("userId"), // or from your auth provider
  username: sessionStorage.getItem("username") || "You",
};
  const users = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user"));

  const [commentsEnabled, setCommentsEnabled] = useState(false);
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };
  // ✅ Define state properly
  const [isOpen, setIsOpen] = useState(false);

  const [isLive, setIsLive] = useState(false); // Tracks Go Live state
  // const [cameraStream, setCameraStream] = useState(null);
  // const [cameraError, setCameraError] = useState(false); // Tracks camera errors
  const [chatMessages, setChatMessages] = useState([]);
  // const videoRef = useRef(null);

  // New state for stream session
  const [streamId, setStreamId] = useState(null);
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [tags, setTags] = useState([]);
const INGEST_URL = "rtmps://caa5358a392b.global-contribute.live-video.net:443/app/";
const broadcastClientRef = useRef(null);



  // Dummy chat data for when live
  const liveChatMessages = [
    {
      id: 1,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 2,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 3,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 4,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 5,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 6,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 7,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 8,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 9,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
  ];

 // Put these near the top with your other hooks:
const videoRef = useRef(null);
const [cameraStream, setCameraStream] = useState(null);
const [cameraError, setCameraError] = useState(false);

// START CAMERA
const startCamera = async () => {
  setCameraError(false);

  try {
    // navigator.permissions.query may not be supported in all browsers - wrap it
    try {
      const perm = await navigator.permissions.query?.({ name: "camera" });
      if (perm && perm.state === "denied") {
        alert(
          "Camera access is blocked. Click the lock icon next to the URL and allow Camera, then refresh."
        );
        return;
      }
    } catch (permErr) {
      // ignore permission API errors and continue to request getUserMedia
      console.debug("Permissions API not available or failed:", permErr);
    }

    // Request camera + mic (you can set audio:false if you want preview without mic)
    const stream = await navigator.mediaDevices.getUserMedia({
      video: { width: 1280, height: 720, facingMode: "user" },
      audio: true,
    });

    // Save stream to state (we attach to the video element in useEffect below)
    setCameraStream(stream);
    setChatMessages(liveChatMessages);

    // debug
    console.log("✅ getUserMedia success, tracks:", stream.getTracks());
  } catch (err) {
    console.error("Error accessing camera/microphone:", err);
    setCameraError(true);
  }
};

// ATTACH STREAM TO VIDEO AFTER RERENDER
useEffect(() => {
  let tryPlayTimeout = null;

  const attach = async () => {
    if (!cameraStream || !videoRef.current) return;

    try {
      videoRef.current.srcObject = cameraStream;
      videoRef.current.muted = true; // required for autoplay in many browsers (preview)
      // ensure playsInline and autoplay attributes are present on the element (see JSX below)
      const playPromise = videoRef.current.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch((err) => {
          // autoplay might be blocked; try again shortly
          console.warn("video.play() was rejected:", err);
          // small retry after a short delay
          tryPlayTimeout = setTimeout(() => {
            videoRef.current?.play().catch((e) => console.warn("retry play failed", e));
          }, 200);
        });
      }
    } catch (err) {
      console.error("Attach stream error:", err);
    }
  };

  attach();

  return () => {
    if (tryPlayTimeout) clearTimeout(tryPlayTimeout);
  };
}, [cameraStream]);

// STOP CAMERA
const stopCamera = () => {
  try {
    // stop media tracks stored in state
    if (cameraStream) {
      cameraStream.getTracks().forEach((t) => {
        try { t.stop(); } catch (e) { /* ignore */ }
      });
      setCameraStream(null);
    }

    // also pause and clear the video element
    if (videoRef.current) {
      try {
        videoRef.current.pause();
      } catch (e) {}
      try {
        videoRef.current.srcObject = null;
      } catch (e) {}
    }
    setChatMessages([]);
    // do NOT change isLive here if you manage it from handleGoLive
  } catch (err) {
    console.error("stopCamera error:", err);
  }
};

// CLEANUP ON UNMOUNT (important)
useEffect(() => {
  return () => {
    if (cameraStream) {
      cameraStream.getTracks().forEach((t) => {
        try { t.stop(); } catch (e) {}
      });
    }
  };
}, []); // run only on unmount


  const getAuthHeaders = () => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) {
      throw new Error("Authentication token is missing. Please log in again.");
    }
    return {
      "Content-Type": "application/json",
      token, // ✅ send as header
    };
  };

  // 1️⃣ Initialize Live Stream
  const initLiveStream = async () => {
    try {
      const res = await fetch(`${BASE_URL}/live/init`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ recording_enabled: false }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        const { stream_id } = data.result;
        // ✅ Pass stream_id directly instead of waiting for state
        await saveMetadata(stream_id);
        console.log("Stream initialized:", data.result);
      } else {
        console.error("Init Stream failed:", data.message);
      }
    } catch (err) {
      console.error("Init Stream Error:", err);
    }
  };

  // 2️⃣ Save Metadata
  const saveMetadata = async (id) => {
    const sid = id || streamId; // ✅ Prefer passed id, fallback to state
    if (!sid) return;
    try {
      const res = await fetch(`${BASE_URL}/live/metadata`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({
          stream_id: sid,
          title,
          category,
          tags,
        }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        console.log("Metadata saved:", data.result);
        await setPreview(sid); // ✅ Chain next step with sid
      } else {
        console.error("Metadata failed:", data.message);
      }
    } catch (err) {
      console.error("Metadata Error:", err);
    }
  };

  // 3️⃣ Set Preview
  const setPreview = async (id) => {
    const sid = id || streamId;
    if (!sid) return;
    try {
      await fetch(`${BASE_URL}/live/preview`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ stream_id: sid }),
      });
      console.log("Stream is in preview mode");
    } catch (err) {
      console.error("Preview Error:", err);
    }
  };
  const [countdown, setCountdown] = useState(0);

  // 4️⃣ Start Live
  const startLive = async (id) => {
    const sid = id || streamId;
    if (!sid) return;
    try {
      await fetch(`${BASE_URL}/live/start`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ stream_id: sid }),
      });
      console.log("Stream started");
    } catch (err) {
      console.error("Start Live Error:", err);
    }
  };

  // 5️⃣ End Live
  const endLive = async (id) => {
    if (broadcastClientRef.current) {
  await broadcastClientRef.current.stopBroadcast();
  broadcastClientRef.current = null;
  console.log("🛑 Broadcast stopped");
}

    const sid = id || streamId;
    if (!sid) return;
    try {
      await fetch(`${BASE_URL}/live/end`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ stream_id: sid }),
      });
      console.log("Stream ended");
      window.location.reload(); // simple way to reset state/UI
  } catch (err) {
      console.error("End Live Error:", err);
    }
  };

  // 🔥 Final Go Live Handler
  // const handleGoLive = async () => {
  //    // ✅ Validate required fields
  // if (!title.trim() || !category.trim()) {
  //   alert("Please enter a title and category before going live.");
  //   return;
  // }
  //   if (isLive) {
  //         await endLive();   // ✅ End first

  //     stopCamera();
  //     // await endLive();
  //     setIsLive(false);
  //         setCountdown(0);

  //   } else {
  //     await initLiveStream();
  //     // await saveMetadata();
  //     // await setPreview();
  //     await startCamera();
  //     await startLive();
  //     setIsLive(true);
  //   }
  // };


const handleGoLive = async () => {
  if (isLive) {
    // 🔴 Stop flow
    await endLive();
    stopCamera();
    setIsLive(false);
    setCountdown(0);
  } else {
    // 🟢 Start flow
    if (!title.trim()) {
      alert("Please fill in Title before going live.");
      return;
    }

    try {
      // 1️⃣ Init API
      const res = await fetch(`${BASE_URL}/live/init`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ recording_enabled: false }),
      });
      const data = await res.json();
      if (!res.ok || !data.success) throw new Error(data.message);

      const sid = data.result.stream_id;
      const streamKey = data.result.stream_key;
      const ingestUrl = `rtmps://caa5358a392b.global-contribute.live-video.net:443/app/${streamKey}`;
      setStreamId(sid);

      // 2️⃣ Metadata
      await fetch(`${BASE_URL}/live/metadata`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({
          stream_id: sid,
          title,
          category: "General", // hardcoded category
          tags: ["live", "react"], // hardcoded tags
        }),
      });

      // 3️⃣ Preview
      await fetch(`${BASE_URL}/live/preview`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ stream_id: sid }),
      });

      // 🎬 Show countdown
      setCountdown(3);
      let timer = 3;
      const interval = setInterval(async () => {
        timer -= 1;
        setCountdown(timer);

        if (timer === 0) {
    clearInterval(interval);

    // ✅ Initialize the Amazon IVS Web Broadcast SDK here
    try {
      const config = BasicStreamConfig.LANDSCAPE;
      const client = IVSBroadcastClient.create({ streamConfig: config });

      // Capture local camera & microphone
      const localStream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });

      const [videoTrack] = localStream.getVideoTracks();
      const [audioTrack] = localStream.getAudioTracks();
      client.addVideoInputDevice(videoTrack);
      client.addAudioInputDevice(audioTrack);

      // Show local camera preview
      if (videoRef.current) {
        videoRef.current.srcObject = localStream;
        client.attachPreview(videoRef.current);
      }

      // Build RTMPS ingest URL using stream_key
      const ingestUrl = `rtmps://caa5358a392b.global-contribute.live-video.net:443/app/${streamKey}`;

      // Start pushing your live stream to IVS
      await client.startBroadcast(ingestUrl);
      console.log("🎥 Stream is live on IVS:", ingestUrl);

      // ✅ Save broadcast client ref so you can stop it later
      broadcastClientRef.current = client;

    } catch (err) {
      console.error("❌ IVS Broadcast Error:", err);
      alert("Failed to start live broadcast.");
      return;
    }

    // 5️⃣ Call backend /live/start API after the IVS broadcast starts
    await startLive(sid);
    setIsLive(true);
    setCountdown(0);
  }
}, 1000);
    } catch (err) {
      console.error("Go Live Error:", err);
      alert(err.message);
    }
  }
};


const [comments, setComments] = useState([]);   // store all comments
const [comment, setComment] = useState("");     // input field value
const [socket, setSocket] = useState(null);
const [viewerCount, setViewerCount] = useState(0);
const [streamStatus, setStreamStatus] = useState("idle");

const deleteComment = async (commentId) => {
  if (!streamId || !commentId) return;

  try {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) {
      alert("Authentication required");
      return;
    }

    const res = await fetch(
      `${BASE_URL}/streams/${streamId}/comments/${commentId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          token,
        },
        body: JSON.stringify({
          stream_id: streamId,
          comment_id: commentId,
        }),
      }
    );

    const data = await res.json();

    if (res.ok && data.success) {
      console.log("✅ Comment deleted:", data.result);
      // Remove from UI
      setComments((prev) =>
        prev.filter((c) => c.commentId !== commentId)
      );
    } else {
      console.error("❌ Delete comment failed:", data.message);
    }
  } catch (err) {
    console.error("Delete Comment Error:", err);
  }
};

const fetchComments = async () => {
  if (!streamId) return;

  try {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) {
      alert("Authentication required");
      return;
    }

    const res = await fetch(`${BASE_URL}/streams/${streamId}/comments?limit=50`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });

    const data = await res.json();

    if (res.ok && data.success) {
      console.log("✅ Comments fetched:", data.result.comments);

      // store the array of comments
      setComments(Array.isArray(data.result.comments) ? data.result.comments : []);
    } else {
      console.error("❌ Fetch comments failed:", data.message);
    }
  } catch (err) {
    console.error("Fetch Comments Error:", err);
  }
};


// ✅ Function to post comment
const postComment = async () => {
  if (!comment.trim() || !streamId) return;

  try {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) {
      alert("Authentication required");
      return;
    }

    const res = await fetch(`${BASE_URL}/streams/${streamId}/comments`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token,
      },
      body: JSON.stringify({
        comment: comment,
        timestamp: new Date().toISOString(),
      }),
    });
      

    const data = await res.json();

    if (res.ok && data.success) {
      console.log("✅ Comment added:", data.result);
      setComment(""); 
setComments((prev) => [
    ...prev,
    {
      commentId: data.result.commentId,
      userId: users.id,
      username: users.username,
      profile_picture_url: users.profile_picture_url,
      comment,
      timestamp: new Date().toISOString(),
    }
  ]);
      // fetch updated comments OR just append new one
      fetchComments();
      // or:
      // setComments((prev) => [...prev, { comment, timestamp: new Date().toISOString(), commentId: data.result.commentId }]);
    } else {
      console.error("❌ Comment failed:", data.message);
    }
  } catch (err) {
    console.error("Comment API Error:", err);
  }
};
useEffect(() => {
  if (streamId) {
    fetchComments();
  }
}, [streamId]);

useEffect(() => {
  if (!streamId) return;

  // ✅ Connect socket
  const s = io(SOCKET_URL, {
    transports: ["websocket"],
    auth: {
      token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"), // send token if required
    },
  });

  setSocket(s);

  // ✅ Join stream comments room
  s.emit("join-stream-comments", {
    streamId,
    userId: profiledata?.id, // your logged in user ID
  });

  // ✅ Handle recent comments (on joining)
  s.on("recent-comments", (data) => {
    console.log("Recent comments:", data);
    setComments(data.comments || []);
  });

  // ✅ Handle new comment
  s.on("new-comment", (data) => {
    console.log("New comment:", data);
    setComments((prev) => [...prev, data]);
  });

  // ✅ Handle deleted comment
  s.on("comment-deleted", (data) => {
    console.log("Comment deleted:", data);
    setComments((prev) => prev.filter((c) => c.commentId !== data.commentId));
  });

  // ✅ Cleanup when leaving
  return () => {
    s.emit("leave-stream-comments", {
      streamId,
      userId: profiledata?.id,
    });
    s.disconnect();
  };
}, [streamId, profiledata?.id]);

useEffect(() => {
  if (!streamId) return;

  const s = io(SOCKET_URL, {
    transports: ["websocket"],
    auth: {
      token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
    },
  });

  setSocket(s);

  // ✅ Join stream room
  s.emit("join-stream", {
    streamId,
    userId: users.id,
  });

  // ✅ Listeners
  s.on("viewer-count-updated", (data) => {
    console.log("Viewer count updated:", data);
    setViewerCount(data.viewerCount);
  });

  s.on("new-viewer", (data) => {
    console.log("New viewer joined:", data);
  });

  s.on("viewer-left", (data) => {
    console.log("Viewer left:", data);
  });

  s.on("stream-initiated", (data) => {
    console.log("Stream initiated:", data);
    setStreamStatus("initiated");
  });

  s.on("stream-preview", (data) => {
    console.log("Stream in preview mode:", data);
    setStreamStatus("preview");
  });

  s.on("stream-started", (data) => {
    console.log("Stream started:", data);
    setStreamStatus("started");
  });

  s.on("stream-went-live", (data) => {
    console.log("Stream went live:", data);
    setStreamStatus("live");
  });

  s.on("stream-ended", (data) => {
    console.log("Stream ended:", data);
    setStreamStatus("ended");
  });

  s.on("stream-room-closed", (data) => {
    console.log("Stream room closed:", data);
    setStreamStatus("closed");
  });

  // ✅ Cleanup
  return () => {
    if (s) {
      s.emit("leave-stream", {
        streamId,
        userId: users.id,
      });
      s.disconnect();
    }
  };
}, [streamId, users?.id]);
if (socket) {
  socket.emit("join-stream", {
    streamId,
    userId: users.id,
  });
}
if (socket) {
  socket.emit("leave-stream", {
    streamId,
    userId: users.id,
  });
}

  return (
    <div className="dashboard w-full min-h-screen  flex">
      {/* Sidebar */}
      <Leftsidebar />
      <main className="flex-1 min-w-0 p-6 go-live">
        <div className="px-6 pt-6 navbar-golive">
          <LeftResponsivesidebar />
          <Headmenu />
        </div>
        {/* <LeftResponsivesidebar />
                <Headmenu /> */}
        {/* Main Content */}
        <main className="row flex flex-col lg:flex-row items-stretch golivresponsive">
          <div className="flex-1 min-w-0 lg:pr-5 space-y-6">
            {/* GoLive Content */}
            <div className="pt-0">
              {/* Add Title Input */}
              <div className="add-title-golive">
                <input
                  type="text"
                   value={title}
        onChange={(e) => setTitle(e.target.value)}
                  placeholder="Add Title..."
                  className="w-full p-3 border border-[#095228] rounded-full mb-4 go-live-add-title"
                />
                  {/* <input
        type="text"
        placeholder="Category..."
        value={category}
        onChange={(e) => setCategory(e.target.value)}
      />
      <input
        type="text"
        placeholder="Tags (comma separated)"
        value={tags.join(",")}
        onChange={(e) => setTags(e.target.value.split(","))}
      /> */}
              </div>
              <div className="bg-green-100 golive-body">
                {/* Camera Screen Placeholder */}
                <div className="bg-black text-white flex flex-col items-center justify-center camera relative h-[500px]">
                  {cameraStream ? (
                    <div className="">
                      <div className="absolute top-9 left-0 bg-[#ffffff73] profile-img">
                        <div className="flex p-2 pl-5 items-center">
                          {/* Profile Image Inside Textarea */}
                          <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                            <img
                              src={profilePictureUrl || profileimg}
                              alt="Profile"
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <div className="feed-title pl-4">
                            <p className="font-semibold text-[#000]">
{user?.first_name}  {user?.last_name} 
                          </p>
                            <p className="flex text-sm text-[#000]">
    {startTime && formatDate(startTime)}
                            </p>
                          </div>
                        </div>
                      </div>
{countdown > 0 && (
  <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-70 text-white text-4xl font-bold z-50">
    Going live in {countdown}...
  </div>
)}

<video
  ref={videoRef}
  autoPlay
  playsInline
  muted
  style={{ width: "100%", height: "100%", backgroundColor: "black" }}
  className="w-full h-full object-cover"
/>

<div className="absolute top-3 left-3 bg-black bg-opacity-50 text-white px-3 py-1 rounded-md">
  Status: {streamStatus}
</div>
                      {/* Show Like Button only when live */}
                      {isLive && (
                        <button className=" text-white px-5 mx-2 py-1 rounded-[20px] absolute left-3 bottom-5">
    👀 {viewerCount} Viewers
                        </button>
                      )}
                      {/* Show Like Button only when live */}
                      {isLive && (
                        <button className="bg-[#BE1F2E] text-white px-5 mx-2 py-1 rounded-[20px] absolute right-3 bottom-5">
                          LIVE
                        </button>
                      )}
                    </div>
                  ) : cameraError ? (
                    <>
                      <div className="absolute top-9 left-0 bg-[#ffffff73] profile-img">
                        <div className="flex p-2 pl-5 items-center">
                          {/* Profile Image Inside Textarea */}
                          <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                            <img
                              src={profilePictureUrl || profileimg}
                              alt="Profile"
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <div className="feed-title pl-4">
                            <p className="font-semibold text-[#000]">
{user?.first_name}  {user?.last_name} 
                  </p>
                            
                            <p className="flex text-sm text-[#000]">
    {startTime && formatDate(startTime)}
                            </p>
                          </div>
                        </div>
                      </div>
                      <img src={golivecam} alt="Go Live Camera" />
                      <p className="text-lg font-semibold">
                        Allow Access To Camera
                      </p>
                      <p className="text-sm text-gray-400 px-8 text-center">
                        Your Browser Is Not Allowing Live Producer Access To
                        Your Camera. Go To Your Browser Settings And Allow
                        Camera Permission.
                      </p>
                      <button
                        className="mt-4 px-6 py-2 bg-[#D9D9D9] text-[#000000] font-semibold rounded-xl"
                        onClick={startCamera} // ✅ Calls updated function
                      >
                        Retry
                      </button>
                    </>
                  ) : (
                    <>
                      <div
                        className="relative bg-cover bg-center h-[500px] w-full camera text-center"
                        style={{ backgroundImage: `url(${golivebanner})` }} // ✅ Dynamic Banner Image
                      >
                        <div className="absolute top-9 left-0 bg-[#ffffff73] profile-img">
                          <div className="flex p-2 pl-5 items-center">
                            {/* Profile Image Inside Textarea */}
                            <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                              <img
                                src={profilePictureUrl || profileimg}
                                alt="Profile"
                                className="w-full h-full object-cover"
                              />
                            </div>
                            <div className="feed-title pl-4">
                              <p className="font-semibold text-[#000]">
{user?.first_name}  {user?.last_name} 
         </p>
                              <p className="flex text-sm text-[#000]">
    {startTime && formatDate(startTime)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                {/* Controls */}
                <div className="golive-controls flex items-center justify-between p-4 rounded-lg">
                  <div className="flex space-x-4">
                    <button className="p-5 bg-[#FFFFFF80] rounded-full shadow-md cam-off">
                      <img src={cameraoff} className="w-5" />
                    </button>
                    <button className="p-5 bg-[#FFFFFF80] rounded-full shadow-md cam-off">
                      <img src={videoslash} className="w-5" />
                    </button>

                    {/* Toggle Switch */}
                    <label className="inline-flex items-center cursor-pointer relative toggle-golive">
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={commentsEnabled}
                        onChange={() => setCommentsEnabled(!commentsEnabled)}
                      />
                      <div
                        className={`relative w-14 h-8 bg-[#095228] rounded-full peer-checked:bg-[#161F28] ${
                          commentsEnabled ? "bg-[#095228]" : "bg-[#161F28]"
                        }`}
                      >
                        {/* Knob */}
                        <div
                          className={`absolute top-[3px] left-[5px] w-6 h-6 bg-white border border-[#161F28] rounded-full transition-all ${
                            commentsEnabled ? "translate-x-full" : ""
                          }`}
                        />
                        {/* Single Span for ON/OFF */}
                        <span
                          className={`absolute text-xs text-white top-4 transform -translate-y-1/2 
                                                ${
                                                  commentsEnabled
                                                    ? "left-2"
                                                    : "left-8"
                                                }`}
                        >
                          {commentsEnabled ? "ON" : "OFF"}
                        </span>
                      </div>
                      <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300 ">
                        Comments
                      </span>
                    </label>
                  </div>
                  <div className="flex items-center space-x-4">
                    <div className="relative hidden md:block">
                      <button
                        onClick={toggleDropdown}
                        className="share-public flex items-center px-4 py-2"
                      >
                        <img src={global} alt="Globe" className="pr-2" />
                        Public
                        <FaChevronDown className="ml-2 text-xs text-gray-400" />
                      </button>

                      {/* ✅ Show dropdown only if isOpen is true */}
                      {isOpen && (
                        <div className="absolute top-12 left-0 bg-white shadow-md rounded-md w-40 p-2">
                          <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">
                            Option 1
                          </button>
                          <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">
                            Option 2
                          </button>
                          <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">
                            Option 3
                          </button>
                        </div>
                      )}
                    </div>
                    {/* Go Live Button */}
                    <div className="flex items-center justify-center">
                      <button
                        className={`px-8 py-2 rounded-full font-semibold
                                                ${
                                                  isLive
                                                    ? "bg-[#BE1F2E] text-white font-semibold"
                                                    : "bg-blue-500 text-white px-8 py-2 rounded-full go-to-live-CTA"
                                                }`}
                        onClick={handleGoLive}
                          // disabled={!title.trim() || !category.trim()} // ✅ Disable if fields missing

                      >
  {isLive ? "Stop" : countdown > 0 ? `Going Live in ${countdown}s...` : "Go Live"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Right Sidebar */}
          {/* Chat Section */}

          <div className="golive-chatbox w-full max-lg:max-w-none lg:w-auto bg-[#F9FAFB] p-4 mb-5 h-[650px] relative">
            <div className="absolute top-0 right-0 w-full h-[50%] z-10 bg-gradient-to-t from-[#ffffff00] to-[#ffffff] pointer-events-none" />

          <div className="h-full overflow-y-auto space-y-4 relative scrollbar-hidden">
 <div className="comments-section p-4">
 {comments.map((c) => (
  <div key={c.commentId} className="p-3 rounded-md relative group">
    <div className="flex">
      <img src={profileimg} className="w-9" alt="profile" />
      <div className="pl-2">
        <p className="font-semibold">{c.username || "Anonymous"}</p>
        <p className="text-[10px] text-gray-500">
          {new Date(c.timestamp).toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })}
        </p>
      </div>
    </div>
    <p className="text-[12px] break-words pt-2">{c.comment}</p>
    <hr className="mt-2 pt-[1px] bg-[#D9D9D9]" />

    {/* Show delete only if the comment belongs to current user */}
    {c.userId === users.id && (
      <button
        onClick={() => deleteComment(c.commentId)}
        className="absolute top-2 right-2 text-red-500 hover:text-red-700"
      >
        Delete
      </button>
    )}
  </div>
))}

</div>


</div>

            {/* Add Comment Input */}
            <div className="flex items-center mt-4 w-full absolute bottom-2 right-0">
              <div className="relative flex flex-1 min-w-0 mx-2">
                <input
                  type="text"
                  placeholder="Add a comment"
                   value={comment}
    onChange={(e) => setComment(e.target.value)}
                  className="flex-1 min-w-0 p-3 border border-gray-300 rounded-full focus:outline-none"
                />
                <button      onClick={postComment}
 className="bg-blue-500 text-white px-4 py-2 rounded-full go-to-live-CTA absolute right-1 top-1">
                  Send
                </button>
              </div>
              {/* Show Like Button only when live */}
              {isLive && (
                <button className="shrink-0 bg-[#BE1F2E] text-white px-3 mx-2 py-3 rounded-full">
                  <img src={like} alt="Like" />
                </button>
              )}
            </div>
            {/* Footer */}
            <div className="lg:hidden">
              <div className="copy-rights pb-5 text-center text-sm text-[#095228]">
                © 2025 Nyawoo. All Rights Reserved
              </div>
            </div>
          </div>
        </main>
      </main>
    </div>
  );
}
